import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Spinner from "../../Common/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { syncResumeDataRequest } from "../../../redux/recruiter/sync_resume_data/actions";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import { showToast } from "../../Common/Toast";

const PreviewResumeModal = (props) => {
  const [isLoading, setLoading] = useState(true);
  const [resumeContent, setResumeContent] = useState("");
  const [syncing, setSyncing] = useState(false);
  const dispatch = useDispatch();
  const syncResumeData = useSelector((state) => state.syncResumeDataReducer);

  const handleAccept = () => {
    if (props.data && props.data.seeker_id) {
      setSyncing(true);
      dispatch(syncResumeDataRequest({ seeker_id: props.data.seeker_id }));
    }
  };

  const handleReject = () => {
    props.toggleModal();
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      // const resumeUrl = props.isViewFromHyperlink && props.data.resume_by_jobseeker 
      //   ? props.data.resume_by_jobseeker 
      //   : props.data.jobseeker_resume;
    let resumeUrl;

    if (props.isViewFromHyperlink && props.data.resume_by_jobseeker) {
      // First choice: hyperlink view with resume_by_jobseeker available
      resumeUrl = props.data.resume_by_jobseeker;
    } else if (props.data.jobseeker_resume) {
      // Second choice: jobseeker_resume exists
      resumeUrl = props.data.jobseeker_resume;
    } else {
      // Fallback: jobseeker_resume empty, use resume_by_jobseeker if available
      resumeUrl = props.data.resume_by_jobseeker || "";
    }
      setResumeContent(resumeUrl);
      setLoading(false);
    }, 2000);
  }, [props.data.jobseeker_resume, props.data.resume_by_jobseeker, props.isViewFromHyperlink]);

  // Handle sync resume data response
  useEffect(() => {
    if (syncing) {
      if (syncResumeData.success) {
        setSyncing(false);
        showToast("success", "Resume Updates Successfully");
        if (props.data && props.data.seeker_id) {
          dispatch(fetchJobseekerDataRequest({ seeker_id: props.data.seeker_id }));
        }
        // Close modal after a short delay to allow user to see toast
        setTimeout(() => {
          props.toggleModal();
        }, 1000);
      } else if (syncResumeData.error) {
        setSyncing(false);
        showToast("error", syncResumeData.error?.message || "Failed to update resume");
      }
    }
  }, [syncResumeData.success, syncResumeData.error]);

  const getViewerUrl = (url) => {
    // Use Google Docs viewer (gview) to handle pdf/doc/docx reliably inside an iframe
    return `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(url)}`;
  };

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      centered
      className="modal-lg"
    >
      <ModalHeader toggle={props.toggleModal}>
        {props.isViewFromHyperlink ? "Resume Preview" : (props.data.resume_name || "Resume Preview")}
      </ModalHeader>
      <ModalBody className="text-center" style={{ height: "600px", position: "relative" }}>
        {(isLoading || syncing) && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.7)",
              zIndex: 10,
            }}
          >
            <Spinner />
          </div>
        )}
        {!isLoading && !syncing && resumeContent ? (
          <iframe
            title="Resume Preview"
            src={getViewerUrl(resumeContent)}
            style={{ border: 0 }}
            width="100%"
            height="100%"
            allowFullScreen
          />
        ) : null}
        {!isLoading && !syncing && !resumeContent && (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
            <p className="text-muted">Resume file not available</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        {props.isViewFromHyperlink ? (
          <>
            <Button 
              color="success" 
              onClick={handleAccept}
              disabled={syncing}
            >
              {syncing ? "Updating..." : "Use Jobseeker’s Resume"}
            </Button>
            <Button color="danger" onClick={handleReject} disabled={syncing}>
              Close
            </Button>
            {/* <Button color="secondary" onClick={props.toggleModal} disabled={syncing}>
              Close
            </Button> */}
          </>
        ) : (
          <Button color="secondary" onClick={props.toggleModal}>
            Close
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default PreviewResumeModal;
